import {switchActive} from '../helpers/ActionHelper';

export class IdentityLifecycleComponent {
    container;
    timelineItems

    constructor() {
        this.container = document.querySelector('.identity-lifecycle');
        this.timelineItems = [...document.querySelectorAll('.identity-timeline__item')];
    }

    initialize() {
        if (!this.container) {
            return;
        }

        this.addEventListeners();
    }

    addEventListeners() {
        const navSwitchers = [...this.container.querySelectorAll('.js-switch-tab')];

        navSwitchers.forEach((navSwitcher) => {
            navSwitcher.addEventListener('click', (e) => this.navSwitcherClickHandler(e));
        });
    }

    navSwitcherClickHandler(e) {
        const target = e.target.closest('.js-switch-tab');
        let targetId = target.id;

        if (!target || target.classList.contains('active')) {
            return;
        }

        switchActive(target);
        
        this.container.dataset.lifecycle = targetId;
                
        this.timelineItems.forEach((timelineItem) => {           
            if ( timelineItem.classList.contains(targetId) ) {
              timelineItem.classList.toggle("active");
            }
        });
        
    }
}